import React, { memo } from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import { cleanseDecimal } from 'src/ui/util';
import { UiInputAdapter, UiSelectAdapter, UiFieldset } from 'src/ui';
import { LOAN_TYPES } from '../const';

function LoanCreditRequestForm({ className, form }) {
  return (
    <UiFieldset title="Credit Request" className={className}>
      <Columns isMultiline>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiSelectAdapter}
            name="loanType"
            id="loanType"
            options={LOAN_TYPES}
            label="Type"
            isCreatable
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanAmount"
            id="loanAmount"
            label="Amount $"
            onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanRepaymentPeriod"
            id="loanRepaymentPeriod"
            label="Repayment Period (months)"
            onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
          />
        </Column>

        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanUseOfFunds"
            id="loanUseOfFunds"
            label="Use of Funds"
          />
        </Column>
      </Columns>
    </UiFieldset>
  );
}

LoanCreditRequestForm.defaultProps = {
  className: '',
};

LoanCreditRequestForm.propTypes = {
  className: propTypes.string,
  form: propTypes.object.isRequired,
};

const memoizedLoanCreditRequestForm = memo(LoanCreditRequestForm);

export { memoizedLoanCreditRequestForm as LoanCreditRequestForm };
